import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { FirmwareUpdateStore } from '@store';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-firmware-update-one-time-approval',
  templateUrl: './firmware-update-one-time-approval.component.html',
  styleUrls: ['./firmware-update-one-time-approval.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmwareUpdateOneTimeApprovalComponent implements OnDestroy {
  @Input() gatewaySerial: string;
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  firmwareUpdateCaseNumberControl: FormControl;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(public firmwareUpdateStore: FirmwareUpdateStore, private fb: FormBuilder) {
    this.firmwareUpdateCaseNumberControl = this.fb.control('', [Validators.required]);
  }

  onApply(): void {
    this.firmwareUpdateStore.checkOneTimeServiceApprovalForCheckingProcess(
      this.firmwareUpdateCaseNumberControl.value
    );
  }

  onClose(): void {
    this.cancel.emit();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
